import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { ClickableBoxItem, HeaderInfo } from 'app/components/common/clickableBox/clickableBox.component';
import { AuthService } from 'app/services/auth.service';
import { StorageService } from 'app/services/database/storage.service';
import { UserRepository } from 'app/services/database/user.repository';
import { PresentationService } from 'app/services/presentation/presentation.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { PresentationModel } from 'app/views/presentations/models/presentation.model';
import { UserModel } from 'app/views/user/models/user.model';
import * as moment from 'moment';

@Component({
    selector: 'psm-presentations-list',
    templateUrl: 'presentationsList.component.html'
})

export class PresentationsListComponent implements OnInit {

    private user: UserModel;

    // Prevents flickers
    public isPresentationListEmpty: boolean = false;
    public isPresentationListLoading: boolean = false;

    private presentationModels: PresentationModel[] = [];
    public sortedPresentationBoxes: ClickableBoxItem[] = [];

    private logger: Logger;

    constructor(
        private authService: AuthService,
        private presentationService: PresentationService,
        private userRepository: UserRepository,
        private loggerFactory: LoggerFactory,
        private toasterService: ToasterService,
        private translate: TranslateService
    ) {
        this.logger = loggerFactory.create('PresentationListComponent');
    }

    public async ngOnInit() {
        let user = await this.authService.getCurrentUser();
        let uid = user.uid;
        this.user = await this.userRepository.get(uid);

        if (this.user.presentations !== undefined) {
            this.isPresentationListLoading = true;
            try {
                try {
                    this.presentationModels = await this.presentationService.getUserPresentationList(uid);
                } catch (err) {
                    this.toasterService.popAsync('error', '', 'modules.presentations.list.failed-to-retrieve-list');
                    this.logger.error(`An error occured while getting presentations for user '${uid}'.`, err);
                }
                for (let presentationModel of this.presentationModels) {
                    try {
                        this.sortedPresentationBoxes.push(await this.createClickableItem(presentationModel));
                    } catch (e) {
                        this.logger.error(`An error occured while creating a clickable item.`, e);
                    }
                }
            } catch (e) {
                this.toasterService.popAsync('error', '', 'modules.presentations.list.failed-to-display-list');
                this.logger.error(`An error occured while displaying presentations for user '${uid}'.`, e);
                this.isPresentationListEmpty = true;
            }
        } else {
            this.isPresentationListEmpty = true;
        }
        this.isPresentationListLoading = false;
    }

    private async createClickableItem(presentation: PresentationModel): Promise<ClickableBoxItem> {
        let link = `/presentations/edit/${presentation.id}`;
        let item = new ClickableBoxItem(presentation.name, link);
        let uid = (await this.authService.getCurrentUser()).uid;
        item.title = presentation.name;
        item.image = await this.presentationService.getThumbnailUrl(presentation);

        let label = await this.translate.get('time.last-modified').toPromise();
        let date = moment(presentation.modificationDate);
        item.headerInfo.push(new HeaderInfo(label, date.format('LLL'), 'fa fa-pencil-square-o'));

        if (presentation.description) {
            item.additionalInfo.push(presentation.description);
        }
        return item;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/presentationsList.component.ts